// Generated by purs version 0.15.15
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Ordering from "../Data.Ordering/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Foreign_Encoding from "../Foreign.Encoding/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Restaumatic_Form_TestHelpers from "../Restaumatic.Form.TestHelpers/index.js";
import * as Restaumatic_Menu_V2_Types_CartToOrder from "../Restaumatic.Menu.V2.Types.CartToOrder/index.js";
import * as Restaumatic_Menu_V2_Types_VatRate from "../Restaumatic.Menu.V2.Types.VatRate/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble_Generic from "../Unscramble.Generic/index.js";
var eq1 = /* #__PURE__ */ Data_Eq.eq(Data_Money_Rounded.eqMoney);
var eq2 = /* #__PURE__ */ Data_Eq.eq(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Menu_V2_Types_VatRate.eqVatRate));
var eq3 = /* #__PURE__ */ Data_Eq.eq(Restaumatic_Menu_V2_Types_CartToOrder.eqCartProductKey);
var compare = /* #__PURE__ */ Data_Ord.compare(Data_Ord.ordString);
var compare1 = /* #__PURE__ */ Data_Ord.compare(Data_Money_Rounded.ordMoney);
var compare2 = /* #__PURE__ */ Data_Ord.compare(/* #__PURE__ */ Data_Maybe.ordMaybe(Restaumatic_Menu_V2_Types_VatRate.ordVatRate));
var compare3 = /* #__PURE__ */ Data_Ord.compare(Restaumatic_Menu_V2_Types_CartToOrder.ordCartProductKey);
var nameIsSymbol = {
    reflectSymbol: function () {
        return "name";
    }
};
var priceIsSymbol = {
    reflectSymbol: function () {
        return "price";
    }
};
var vatRateIsSymbol = {
    reflectSymbol: function () {
        return "vatRate";
    }
};
var CustomProductKeyIsSymbol = {
    reflectSymbol: function () {
        return "CustomProductKey";
    }
};
var CustomProductIsSymbol = {
    reflectSymbol: function () {
        return "CustomProduct";
    }
};
var MenuProductIsSymbol = {
    reflectSymbol: function () {
        return "MenuProduct";
    }
};
var encodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.encodeRecordCons();
var decodeRecordCons = /* #__PURE__ */ Foreign_Generic_Class.decodeRecordCons();
var CustomProductKey = function (x) {
    return x;
};
var CustomProduct = /* #__PURE__ */ (function () {
    function CustomProduct(value0) {
        this.value0 = value0;
    };
    CustomProduct.create = function (value0) {
        return new CustomProduct(value0);
    };
    return CustomProduct;
})();
var MenuProduct = /* #__PURE__ */ (function () {
    function MenuProduct(value0) {
        this.value0 = value0;
    };
    MenuProduct.create = function (value0) {
        return new MenuProduct(value0);
    };
    return MenuProduct;
})();
var toFillFormTypeProductKey = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var toFillFormTypeCustomProdu = {
    fillFormDataType: function (v) {
        return Restaumatic_Form_TestHelpers.tyVar("unknown");
    }
};
var newtypeCustomProductKey_ = {
    Coercible0: function () {
        return undefined;
    }
};
var hasFieldCustomProductKey = function (dictHasField) {
    return dictHasField;
};
var eqCustomProductKey = {
    eq: function (x) {
        return function (y) {
            return x.name === y.name && eq1(x.price)(y.price) && eq2(x.vatRate)(y.vatRate);
        };
    }
};
var eq4 = /* #__PURE__ */ Data_Eq.eq(eqCustomProductKey);
var eqProductKey = {
    eq: function (x) {
        return function (y) {
            if (x instanceof CustomProduct && y instanceof CustomProduct) {
                return eq4(x.value0)(y.value0);
            };
            if (x instanceof MenuProduct && y instanceof MenuProduct) {
                return eq3(x.value0)(y.value0);
            };
            return false;
        };
    }
};
var ordCustomProductKey = {
    compare: function (x) {
        return function (y) {
            var v = compare(x.name)(y.name);
            if (v instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            var v1 = compare1(x.price)(y.price);
            if (v1 instanceof Data_Ordering.LT) {
                return Data_Ordering.LT.value;
            };
            if (v1 instanceof Data_Ordering.GT) {
                return Data_Ordering.GT.value;
            };
            return compare2(x.vatRate)(y.vatRate);
        };
    },
    Eq0: function () {
        return eqCustomProductKey;
    }
};
var compare4 = /* #__PURE__ */ Data_Ord.compare(ordCustomProductKey);
var ordProductKey = {
    compare: function (x) {
        return function (y) {
            if (x instanceof CustomProduct && y instanceof CustomProduct) {
                return compare4(x.value0)(y.value0);
            };
            if (x instanceof CustomProduct) {
                return Data_Ordering.LT.value;
            };
            if (y instanceof CustomProduct) {
                return Data_Ordering.GT.value;
            };
            if (x instanceof MenuProduct && y instanceof MenuProduct) {
                return compare3(x.value0)(y.value0);
            };
            throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 0, column 0 - line 0, column 0): " + [ x.constructor.name, y.constructor.name ]);
        };
    },
    Eq0: function () {
        return eqProductKey;
    }
};
var genericProductKey = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new CustomProduct(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new MenuProduct(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 28, column 1 - line 28, column 75): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof CustomProduct) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof MenuProduct) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Restaumatic.Cart.ProductKey (line 28, column 1 - line 28, column 75): " + [ x.constructor.name ]);
    }
};
var genericCustomProductKey = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showCustomProductKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericCustomProductKey)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons(nameIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(priceIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(vatRateIsSymbol)(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_V2_Types_VatRate.showVatRate)))(Data_Money_Rounded.showMoney))(Data_Show.showString))))(CustomProductKeyIsSymbol))
};
var showProductKey = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericProductKey)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(showCustomProductKey))(CustomProductIsSymbol))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(Restaumatic_Menu_V2_Types_CartToOrder.showCartProductKey))(MenuProductIsSymbol)))
};
var unscrambleDecodeCustomProductKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericCustomProductKey)(/* #__PURE__ */ Unscramble_Generic.genericDecodeConstructor(/* #__PURE__ */ Unscramble_Generic.genericDecodeArgsArgument(/* #__PURE__ */ Unscramble.decodeRecord1()(/* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(Unscramble.decodeString1)(/* #__PURE__ */ Unscramble.decodeRecordCons(priceIsSymbol)(Data_Money_Rounded.udecodeMoney)(/* #__PURE__ */ Unscramble.decodeRecordCons(vatRateIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic_Menu_V2_Types_VatRate.unscrambleDecodeVatRate))(Unscramble.decodeRecordNil)))))))(Unscramble_Generic.defaultOptions)
};
var unscrambleDecodeProductKey = {
    unsafeDecode: /* #__PURE__ */ Unscramble_Generic.genericUnsafeDecode(genericProductKey)(/* #__PURE__ */ Unscramble_Generic.genericDecode(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumSum(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(CustomProductIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(unscrambleDecodeCustomProductKey)))(/* #__PURE__ */ Unscramble_Generic.genericDecodeSumConstruct(MenuProductIsSymbol)(/* #__PURE__ */ Unscramble_Generic.decodeSingleConstructorAr1(Restaumatic_Menu_V2_Types_CartToOrder.unscrambleDecodeCartProductKey)))))(Unscramble_Generic.defaultOptions)
};
var encodeCustomProductKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericCustomProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CustomProductKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsRecord()(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(/* #__PURE__ */ encodeRecordCons(Foreign_Generic_Class.encodeRecordNil)(vatRateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeEncode(Restaumatic_Menu_V2_Types_VatRate.encodeVatRate))))(priceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Data_Money_Rounded.encodeMoney)))(nameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Foreign_Generic_Class.stringEncode))))))
};
var encodeProductKey = {
    encode: /* #__PURE__ */ Foreign_Encoding.defaultEncode(genericProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(CustomProductIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(encodeCustomProductKey))))(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeConstructor(MenuProductIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericEncodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.encodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.encodeCartProductKey)))))
};
var decodeCustomProductKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericCustomProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CustomProductKeyIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsRecord(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsRecord()(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(/* #__PURE__ */ decodeRecordCons(Foreign_Generic_Class.decodeRecordNil)(vatRateIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(/* #__PURE__ */ Foreign_Generic_Class.maybeDecode(Restaumatic_Menu_V2_Types_VatRate.decodeVatRate)))())(priceIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Data_Money_Rounded.decodeMoney))())(nameIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Foreign_Generic_Class.stringDecode))())))(Foreign_Generic_Class.genericCountArgsArgument))
};
var decodeProductKey = {
    decode: /* #__PURE__ */ Foreign_Encoding.defaultDecode(genericProductKey)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeSum(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(CustomProductIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(decodeCustomProductKey)))(Foreign_Generic_Class.genericCountArgsArgument))(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeConstructor(MenuProductIsSymbol)(/* #__PURE__ */ Foreign_Generic_Class.genericDecodeArgsArgument(/* #__PURE__ */ Foreign_Generic_Class.decodeWithOptionsOther(Restaumatic_Menu_V2_Types_CartToOrder.decodeCartProductKey)))(Foreign_Generic_Class.genericCountArgsArgument)))
};
export {
    CustomProduct,
    MenuProduct,
    CustomProductKey,
    genericProductKey,
    eqProductKey,
    showProductKey,
    ordProductKey,
    encodeProductKey,
    decodeProductKey,
    unscrambleDecodeProductKey,
    toFillFormTypeProductKey,
    genericCustomProductKey,
    eqCustomProductKey,
    showCustomProductKey,
    ordCustomProductKey,
    encodeCustomProductKey,
    decodeCustomProductKey,
    unscrambleDecodeCustomProductKey,
    toFillFormTypeCustomProdu,
    hasFieldCustomProductKey,
    newtypeCustomProductKey_
};
